<template>
  <v-dialog v-model="toggle" max-width="550px">
    <v-card
    >
      <v-card-text class="mb-2 py-4">
        <v-row class="mx-3">
          <v-col cols="12">
            <h2 class="primary--text d-inline-block mt-2">Information details</h2>
            <v-btn icon class="gray--text float-right" @click="toggle = false">
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>
          </v-col>

          <!-- Country -->
          <v-col
            cols="8"
            class="py-1"
          >
            <span class="grey--text caption">Country</span>
            <h3 class="black--text">{{ country }}</h3>
          </v-col>

          <!-- Dependents -->
          <v-col
            cols="4"
            class="py-1"
          >
            <template v-if="dependents">
              <span class="grey--text caption">No. of Dependents</span>
              <h3 class="black--text">{{ dependents }}</h3>
            </template>
          </v-col>

          <!-- Full Name -->
          <v-col
            cols="12"
            class="py-1"
          >
            <span class="grey--text caption">Full Name</span>
            <h3 class="black--text">{{ middleName ? `${firstName} ${middleName} ${lastName}` :  `${firstName} ${lastName}` }}</h3>
          </v-col>

          <!-- Address 1 -->
          <v-col
            cols="12"
            class="py-1"
          >
            <span class="grey--text caption">Address 1</span>
            <h3 class="black--text">{{ address1 }}</h3>
          </v-col>

          <!-- City -->
          <v-col
            cols="4"
            class="py-1"
          >
            <span class="grey--text caption">City</span>
            <h3 class="black--text">{{ city }}</h3>
          </v-col>

          <!-- State -->
          <v-col
            cols="4"
            class="py-1"
          >
            <span class="grey--text caption">State</span>
            <h3 class="black--text">{{ state }}</h3>
          </v-col>

          <!-- Zip Code -->
          <v-col
            cols="4"
            class="py-1"
          >
            <span class="grey--text caption">Zip Code</span>
            <h3 class="black--text">{{ zip }}</h3>
          </v-col>

          <!-- Phone number -->
          <v-col
            cols="12"
            class="py-1"
          >
            <span class="grey--text caption">Phone number</span>
            <h3 class="black--text">{{ phoneNumber }}</h3>
          </v-col>

          <!-- Email -->
          <v-col
            cols="12"
            class="py-1"
          >
            <span class="grey--text caption">Email</span>
            <h3 class="black--text">{{ email }}</h3>
          </v-col>

          <!-- Source of information -->
          <v-col
            cols="12"
            class="py-1"
          >
            <span class="grey--text caption">Source of information</span>
            <h3 class="black--text">{{ source }}</h3>
          </v-col>

        </v-row>
      </v-card-text>

      <hr>

      <v-card-actions>
        <slot name="confirm-button"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "BillConfirmDialog",

    props: {
      value: { type: Boolean, default: false },
      country: { type: String, default: '' },
      firstName: { type: String, default: '' },
      middleName: { type: String, default: '' },
      lastName: { type: String, default: '' },
      address1: { type: String, default: '' },
      city: { type: String, default: '' },
      state: { type: String, default: '' },
      zip: { type: String, default: '' },
      phoneNumber: { type: String, default: '' },
      email: { type: String, default: '' },
      source: { type: String, default: '' },
      dependents: { type: Number, default: 0 }
    },

    data() {
      return {
        toggle: this.value
      }
    },

    watch: {
      value(val) {
        this.toggle = val;
      },
      toggle(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>